<template>
  <div class="hospital">
    <div class="hospital-background">
      <div class="cardnber-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        欧堡利亚医院
      </div>
      <div class="hospital-rotaon">
        <img src="../../public/obraoag/brefon.png" alt="">
      </div>
      <div class="hospital-content">
        <p>盐城欧堡利亚集团积极响应国家健康发展战略，和盐城国投欧亚集团共同投资打造的盐城欧堡利亚医院，坐落于城南新区新龙广场15号楼，建筑面积近2万平米，其中健康管理中心使用面积8000多平米。</p>
        <p class="hospital-content-spaing">医院配备有西门子全自动生化流水线、16排CT、直接数字平板X线成像系统、高清内镜系统、胶囊胃镜、高清四维彩超、ABUS乳腺筛查系统、贝亿热断层扫描系统(TTM)、GE双能X线骨密度仪，移动体检车等国际国内一线品牌检查设备。还拥有人体成分分析、日本动脉硬化检测、肺功能检测、丹麦电测听、体适能检测等全套健康风险评估设备。</p>
      </div>
      <div class="hospital-exbion">
        <img src="../../public/obraoag/hibion.png" alt="">
      </div>
      <div class="hospital-content hospital-intrce">
        <p>医院有来自盐城市一院、三院、妇保院等三甲医院临床经验丰富的专业团队，聘请各类医、药、技、护专家30多人，和其他医学专业人才近150人，形成各科人才梯队健全的专业队伍。</p>
        <p class="hospital-content-spaing">医院健康管理中心始终坚持以健康管理服务为宗旨，坚持健康体检规范，精心设计检前、检中、检后服务流程，提供健康福利体检、职业健康体检、从业人员健康体检以及个性化体检套餐制定和检后阳性报告解读、医学咨询及重大阳性结果健康管理和临床处理。</p>
        <p class="hospital-content-spaing">医院二楼健康管理部设有咨询接待、健康风险评估、健康体适能测评及运动指导区、肥胖及体重管理、营养咨询、慢病管理、妇女青春期和更年期健康管理等专科专家门诊。</p>
        <p class="hospital-content-spaing">医院门诊系统将为市民提供常见社区慢病诊治，妇女青春期、围绝经期保健咨询及健康管理，常见癌症筛查等医疗服务，提供中医药健康养生等适宜技术服务。</p>
      </div>
      <div class="hospital-exbion">
        <img src="../../public/obraoag/exhibi.png" alt="">
      </div>
      <div class="hospital-content hospital-intrce">
        <p>医院有先进的远程会诊信息系统，可根据患者和客户的诊疗需求，将本院的健康检查数据推送至北京301、协和、天坛、上海长海等国家级医疗中心，由相关科室专家进行远程会诊并制定相应的诊疗方案，实现优质医疗资源下沉，为疑似重大疾病人群提供便捷诊疗服务。</p>
        <p class="hospital-content-spaing">医院严格按照国家医学诊疗规范和健康体检标准打造质量管理体系，以严谨的态度，“工匠精神”，确保体检项目的科学性、体检结论的准确性、体检报告的及时性。</p>
        <p class="hospital-content-spaing">医院将不断完善健康管理和临床诊疗服务，不断提升信息智能化体系建设，全面建设健康体检、健康评估、家庭医生咨询、专家门诊健康管理方案制定、远程诊疗、慢病干预、手机客户端推送等线上线下的健康管理新模式，实现疾病筛查和预防、亚健康干预、慢病管理、重特大疾病转诊跟踪服务，全力为市民提供精湛的健康管理服务。</p>
      </div>
    </div>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      
    }
  },
  created () {
    
  },
  mounted () {

  },
  methods: {
    // 返回上一层
    BackLevel(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/hospital.css";
</style>